module.exports = __webpack_public_path__ + "img/btn-download-googleplay.5f35aa0e.png";